/**
 * Constantes pour les messages et codes d'erreur Firebase
 */

// Importer les codes d'erreur directement depuis Firebase
export { AuthErrorCodes } from "firebase/auth"

// Messages d'authentification personnalisés
export const FIREBASE_MESSAGES = {
  // Messages de succès
  UTILISATEUR_CONNECTE: "Utilisateur connecté",
  UTILISATEUR_DECONNECTE: "Utilisateur déconnecté",
  DECONNEXION_OK: "Déconnexion OK",
  EMULATEUR_FIRESTORE_DEJA_CONNECTE: "Émulateur Firestore déjà connecté",

  // Messages d'erreur
  DECONNEXION_KO: "Déconnexion KO",
  MOT_DE_PASSE_NON_VALIDE: "Mot de passe non valide",
}

/**
 * Voir: https://firebase.google.com/docs/reference/js/auth#autherrorcodesmap
 */
